import { render, staticRenderFns } from "./ProductPhotoItem.vue?vue&type=template&id=e27e0d50&scoped=true&"
import script from "./ProductPhotoItem.vue?vue&type=script&lang=js&"
export * from "./ProductPhotoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27e0d50",
  null
  
)

export default component.exports